import Image from "next/image";
import { useMemo } from "react";

import { VariantFinishEnum } from "@sorcery/db";
import { useBreakpoints } from "@sorcery/ui";

import type { VariantType } from "~/types/card";
import { DEFAULT_CARD_HEIGHT, DEFAULT_CARD_WIDTH } from "~/utils/card";

export const CardDisplayImage = ({
  variant,
  rotate,
}: {
  variant: VariantType;
  rotate: boolean;
}) => {
  const { isXl, isLg, isMd, isSm, isXs } = useBreakpoints();

  const multiplyer = isXl
    ? 1.1
    : isLg
      ? 1
      : isMd
        ? 0.8
        : isSm
          ? 0.65
          : isXs
            ? 0.8
            : rotate
              ? 0.6
              : 0.85;

  const h = useMemo(() => {
    return (rotate ? DEFAULT_CARD_WIDTH : DEFAULT_CARD_HEIGHT) * multiplyer;
  }, [rotate, multiplyer]);
  const w = useMemo(() => {
    return (rotate ? DEFAULT_CARD_HEIGHT : DEFAULT_CARD_WIDTH) * multiplyer;
  }, [rotate, multiplyer]);

  const style: React.CSSProperties = useMemo(() => {
    return rotate
      ? {
          transform: "scale(0.715) rotate(90deg) translate(-47.8%, 0)",
        }
      : {};
  }, [rotate]);

  const rounding = useMemo(() => {
    return isXl ? "rounded-[26px]" : isLg ? "rounded-[22px]" : "rounded-[20px]";
  }, [isXl, isLg]);

  return (
    <div
      className="relative duration-500 animate-in fade-in"
      key={variant.id}
      style={{
        height: h,
        width: w,
      }}
    >
      <Image height={h} width={w} style={style} alt={variant.slug} src={variant.src} />
      {variant.finish === VariantFinishEnum.Foil && (
        <div
          className={`absolute left-0 top-0 z-10 h-full w-full opacity-30 ${rounding}`}
          style={{
            background:
              "repeating-linear-gradient(-45deg,rgba(233, 238, 82, 0.5),rgba(231, 60, 126, 0.5),rgba(35, 166, 213, 0.5),rgba(35, 213, 171, 0.5))",
            backgroundSize: "400% 400%",
            backgroundPosition: "0 0",
            animation: "sparkle 5s ease-in-out infinite",
          }}
        />
      )}
    </div>
  );
};
